<ng-container [formGroup]="form">
    <td>{{ name }}</td>
    <td>
        <cm-select
            class="form-select"
            [options]="signatureType"
            display="static"
            [ngClass]="{ 'is-invalid': form.get('signatureType').invalid }"
            required
            formControlName="signatureType"
            (blur)="onTouched()"
        >
        </cm-select>
    </td>
    <td>
        <cm-select
            class="form-select"
            [options]="steps"
            display="static"
            [ngClass]="{ 'is-invalid': form.get('stepId').invalid }"
            required
            formControlName="stepId"
            (blur)="onTouched()"
        >
        </cm-select>
    </td>
</ng-container>
